import { usePreview } from '@/stores/previewStore';
import { Eye, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Global banner shown when admin preview mode is active.
 * Sticky at top of viewport, read-only indicator with exit button.
 */
export function PreviewBanner() {
  const { preview, deactivatePreview } = usePreview();
  if (!preview.active) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 dark:bg-amber-600 text-amber-950 py-1.5 px-4 flex items-center justify-between text-xs font-medium shadow-lg">
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span>Preview-Modus aktiv</span>
        <span className="bg-amber-400/50 dark:bg-amber-500/50 rounded px-2 py-0.5 font-semibold">{preview.label}</span>
        <span className="text-amber-800 dark:text-amber-200 ml-2">Nur Lesen – keine Änderungen möglich</span>
      </div>
      <Button
        size="sm"
        variant="ghost"
        onClick={deactivatePreview}
        className="h-6 px-2 text-amber-950 hover:bg-amber-400/50"
      >
        <X className="w-3.5 h-3.5 mr-1" /> Beenden
      </Button>
    </div>
  );
}
